<template>
  <div class="activitiesManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-activitiesManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">地推人员管理</span>
              <div class="pull-right">
                <el-button @click="addPerson" type="primary"
                  >添加地推人员</el-button
                >
              </div>
            </div>
          </div>
          <div class="activitiesManage-container">
            <div class="content">
              <div class="flex-wrap">
                <div class="flex-al mb12 mr10">
                  <div class="select-box" style="width:170px;">
                    <el-select
                      v-model="selectForms.promotion_type"
                      clearable
                      filterable
                      placeholder="请选择地推类型"
                      @change="search"
                    >
                      <el-option label="市场" value="0"></el-option>
                      <el-option label="销售" value="1"></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al mb12 mr10">
                  <div class="select-box" style="width: 170px">
                    <el-select
                      v-model="selectForms.open_status"
                      clearable
                      filterable
                      placeholder="请选择启用状态"
                      @change="search"
                    >
                      <el-option label="未启用" value="0"></el-option>
                      <el-option label="已启用" value="1"></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      placeholder="可检索地推人员姓名、地推工号、联系电话"
                      class="input-cont"
                      style="width: 320px"
                      v-model="selectForms.keyword"
                      @change="search"
                      @clear="search"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="search"
                    >{{ $t("Crmactivemanage.as") }}</el-button
                  >
                </div>
              </div>
              <div class="tableList" ref="auto_height_table">
                <normalTableCont
                  :tableData="tableList"
                  @switchChange="onSwitchChange"
                >
                  <!-- 按钮操作组********start -->
                  <el-table-column
                    ref="fixedColumn"
                    label="操作"
                    align="center"
                    width="150px"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click.native.prevent="onClickEdit(scope.row)"
                        >编辑</el-button
                      >
                    </template>
                  </el-table-column>
                  <!-- 按钮操作组********end -->
                </normalTableCont>
              </div>
              <el-pagination
                style="margin-top: 35px"
                @size-change="pageSizeChange"
                @current-change="curPageChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <SliderBox
      sliderWidth="600px"
      :showSliderBox="addVisible"
      @hideSliderBox="addVisible = false"
    >
      <div class="silder-contain slider-activitiesManage">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">添加地推人员</p>
          <div
            class="pull-right h1 btn-close font-gray"
            @click="addVisible = false"
          >
            <i class="el-icon-close"></i>
          </div>
          <el-button
            type="primary"
            class="pull-right"
            size="mini"
            @click="submit"
            >确认</el-button
          >
        </div>
        <div class="groundPromotion-manage-drawer">
          <el-form
            :model="formData"
            status-icon
            ref="formData"
            style="margin-left: 0px !important"
          >
            <div v-for="(item, index) in formData.codeList" :key="index">
              <el-form
                :model="item"
                label-width="120px"
                :ref="`Setup${index}`"
                class="code_list"
              >
                <div>
                  <el-form-item
                    label="姓名："
                    prop="promotion_name"
                    :rules="[
                      {
                        required: true,
                        message: '请输入姓名',
                      },
                    ]"
                  >
                    <el-input
                      v-model="item.promotion_name"
                      clearable
                      placeholder="请输入姓名"
                      style="width: 330px"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="性别："
                    prop="promotion_sex"
                    :rules="[
                      {
                        required: false,
                        message: '请选择性别',
                      },
                    ]"
                  >
                    <el-radio-group v-model="item.promotion_sex">
                      <el-radio label="男">男</el-radio>
                      <el-radio label="女">女</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <!-- validator: checkJobnumber, -->
                  <!-- <el-form-item
                    label="地推工号："
                    prop="promotion_jobnumber"
                    :rules="[
                      {
                        required: true,
                        trigger: 'blur',
                        message: '请输入地推工号',
                      },
                    ]"
                  >
                    @blur="getJobnumber(item.promotion_jobnumber)"
                    <el-input
                      v-model="item.promotion_jobnumber"
                      clearable
                      placeholder="请输入地推工号"
                      style="width: 330px"
                    ></el-input>
                  </el-form-item> -->
                  <el-form-item
                    label="联系电话："
                    prop="promotion_mobile"
                    :rules="[
                      {
                        required: true,
                        trigger: 'blur',
                        validator: checkPhone,
                      },
                    ]"
                  >
                    <!-- @blur="getPromotion(item.promotion_mobile, index)" -->
                    <el-input
                      v-model="item.promotion_mobile"
                      clearable
                      placeholder="请输入手机号"
                      style="width: 330px"
                      :disabled="item.disabled"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="地推类型："
                    prop="promotion_type"
                    :rules="[
                      {
                        required: true,
                        message: '请选择地推类型',
                      },
                    ]"
                  >
                    <el-radio-group v-model="item.promotion_type">
                      <el-radio label="0">兼职地推</el-radio>
                      <el-radio label="1">销售老师</el-radio>
                      <el-radio label="2">市场专员</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item
                    label="考核模式："
                    prop="promotion_mode"
                    :rules="[
                      {
                        required: true,
                        message: '请选择考核模式',
                      },
                    ]"
                  >
                    <el-radio-group v-model="item.promotion_mode">
                      <el-radio label="0">无工时费版本</el-radio>
                      <el-radio label="1">有工时费版本</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item
                    label="薪资结算周期："
                    prop="promotion_salarycycle"
                    :rules="[
                      {
                        required: false,
                        message: '请选择薪资结算周期',
                      },
                    ]"
                  >
                    <el-radio-group v-model="item.promotion_salarycycle">
                      <el-radio label="0">暂无</el-radio>
                      <el-radio label="1">周</el-radio>
                      <el-radio label="2">月</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item
                    label="银行卡号："
                    prop="promotion_bankcard"
                    :rules="[
                      {
                        required: false,
                        message: '请输入银行卡号',
                      },
                    ]"
                  >
                    <el-input
                      v-model="item.promotion_bankcard"
                      clearable
                      placeholder="请输入银行卡号"
                      style="width: 330px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="开户行："
                    prop="promotion_bank"
                    :rules="[
                      {
                        required: false,
                        message: '请输入开户行',
                      },
                    ]"
                  >
                    <el-input
                      v-model="item.promotion_bank"
                      clearable
                      placeholder="请输入开户行"
                      style="width: 330px"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="身份证号："
                    prop="promotion_idcard"
                    :rules="[
                      {
                        required: false,
                        message: '请输入身份证号',
                      },
                    ]"
                  >
                    <el-input
                      placeholder="请输入身份证号"
                      clearable
                      style="width: 330px"
                      v-model.trim="item.promotion_idcard"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="身份证文件："
                    prop="promotion_idcardfile"
                    :rules="[
                      {
                        required: false,
                        message: '请输入身份证文件',
                      },
                    ]"
                  >
                    <div class="flex-al">
                      <el-upload
                        :action="$uploadAction('/Uploading/Picture')"
                        name="ossfile"
                        :data="Uploadeimg"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess1"
                        :disabled="!!item.promotion_idcardfile"
                        accept=".doc, .docx, .docm, .dotx, .xls, .xlsx, .xlsm, .pdf, .png, .jpeg, .gif"
                      >
                        <el-button
                          type="primary"
                          :disabled="!!item.promotion_idcardfile"
                        >
                          上传
                        </el-button>
                      </el-upload>

                      <span class="file-item" v-if="item.promotion_idcardfile">
                        {{ item.promotion_idcardfile }}
                        <em
                          class="el-icon-error"
                          @click="item.promotion_idcardfile = ''"
                        ></em>
                      </span>
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="协议文件："
                    prop="promotion_protocolfile"
                    :rules="[
                      {
                        required: false,
                        message: '请输入协议文件',
                      },
                    ]"
                  >
                    <div class="flex-al">
                      <el-upload
                        :action="$uploadAction('/Uploading/Picture')"
                        name="ossfile"
                        :data="Uploadeimg"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess2"
                        :disabled="!!item.promotion_protocolfile"
                        accept=".doc, .docx, .docm, .dotx, .xls, .xlsx, .xlsm, .pdf, .png, .jpeg, .gif"
                      >
                        <el-button
                          type="primary"
                          :disabled="!!item.promotion_protocolfile"
                        >
                          上传
                        </el-button>
                      </el-upload>
                      <span
                        class="file-item"
                        v-if="item.promotion_protocolfile"
                      >
                        {{ item.promotion_protocolfile }}
                        <em
                          class="el-icon-error"
                          @click="item.promotion_protocolfile = ''"
                        ></em>
                      </span>
                    </div>
                  </el-form-item>
                </div>

                <span
                  class="code-remove"
                  @click="delItem(index)"
                  v-if="formData.codeList.length > 1"
                >
                  <i class="el-icon-remove-outline"></i>
                </span>
              </el-form>
            </div>
            <!-- <div class="add-icon" @click="addItem">
              <i class="el-icon-circle-plus"></i>
              <span>继续添加</span>
            </div> -->
          </el-form>
        </div>
      </div>
    </SliderBox>
    <div class="addPlaceDialog">
      <el-dialog
        title="编辑地推人员"
        :visible.sync="editVisible"
        width="550px"
        :before-close="handClose"
      >
        <div class="form">
          <el-form label-width="130px" ref="editForm" :model="editForm">
            <el-form-item
              label="姓名："
              prop="promotion_name"
              :rules="[
                {
                  required: true,
                  message: '请输入姓名',
                },
              ]"
            >
              <el-input
                placeholder="请输入姓名"
                clearable
                style="width: 330px"
                v-model.trim="editForm.promotion_name"
                disabled
              ></el-input>
            </el-form-item>

            <el-form-item
              label="性别："
              prop="promotion_sex"
              :rules="[
                {
                  required: false,
                  message: '请选择性别',
                },
              ]"
            >
              <el-radio-group v-model="editForm.promotion_sex">
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="地推工号："
              prop="promotion_jobnumber"
              :rules="[
                {
                  required: true,
                  message: '请输入地推工号',
                },
              ]"
            >
              <el-input
                disabled
                placeholder="请输入地推工号"
                style="width: 330px"
                v-model.trim="editForm.promotion_jobnumber"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="联系电话："
              prop="promotion_mobile"
              :rules="[
                {
                  required: true,
                  message: '请输入手机号',
                },
              ]"
            >
              <el-input
                disabled
                placeholder="请输入手机号"
                style="width: 330px"
                v-model.trim="editForm.promotion_mobile"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="地推类型："
              prop="promotion_type"
              :rules="[
                {
                  required: true,
                  message: '请选择地推类型',
                },
              ]"
            >
              <el-radio-group disabled v-model="editForm.promotion_type">
                <el-radio label="0">兼职地推</el-radio>
                <el-radio label="1">销售老师</el-radio>
                <el-radio label="2">市场专员</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="考核模式："
              prop="promotion_mode"
              :rules="[
                {
                  required: false,
                  message: '请选择考核模式',
                },
              ]"
            >
              <el-radio-group v-model="editForm.promotion_mode">
                <el-radio label="0">无工时费版本</el-radio>
                <el-radio label="1">有工时费版本</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="薪资结算周期："
              prop="promotion_salarycycle"
              :rules="[
                {
                  required: false,
                  message: '请选择薪资结算周期',
                },
              ]"
            >
              <el-radio-group v-model="editForm.promotion_salarycycle">
                <el-radio label="0">暂无</el-radio>
                <el-radio label="1">周</el-radio>
                <el-radio label="2">月</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item
              label="银行卡号："
              prop="promotion_bankcard"
              :rules="[
                {
                  required: false,
                  message: '请输入银行卡号',
                },
              ]"
            >
              <el-input
                placeholder="请输入银行卡号"
                clearable
                style="width: 330px"
                v-model.trim="editForm.promotion_bankcard"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="开户行："
              prop="promotion_bank"
              :rules="[
                {
                  required: false,
                  message: '请输入开户行',
                },
              ]"
            >
              <el-input
                clearable
                placeholder="请输入开户行"
                style="width: 330px"
                v-model.trim="editForm.promotion_bank"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="身份证号："
              prop="promotion_idcard"
              :rules="[
                {
                  required: false,
                  message: '请输入身份证号',
                },
              ]"
            >
              <el-input
                placeholder="请输入身份证号"
                clearable
                style="width: 330px"
                v-model.trim="editForm.promotion_idcard"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="身份证文件："
              prop="promotion_idcardfile"
              :rules="[
                {
                  required: false,
                  message: '请输入身份证文件',
                },
              ]"
            >
              <div class="flex-al">
                <el-upload
                  :action="$uploadAction('/Uploading/Picture')"
                  name="ossfile"
                  :data="Uploadeimg"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess3"
                  :disabled="!!editForm.promotion_idcardfile"
                  accept=".doc, .docx, .docm, .dotx, .xls, .xlsx, .xlsm, .pdf, .png, .jpeg, .gif"
                >
                  <el-button
                    type="primary"
                    :disabled="!!editForm.promotion_idcardfile"
                  >
                    上传
                  </el-button>
                </el-upload>

                <span class="file-item" v-if="editForm.promotion_idcardfile">
                  {{ editForm.promotion_idcardfile }}
                  <em
                    class="el-icon-error"
                    @click="editForm.promotion_idcardfile = ''"
                  ></em>
                </span>
              </div>
            </el-form-item>
            <el-form-item
              label="协议文件："
              prop="promotion_protocolfile"
              :rules="[
                {
                  required: false,
                  message: '请输入协议文件',
                },
              ]"
            >
              <div class="flex-al">
                <el-upload
                  :action="$uploadAction('/Uploading/Picture')"
                  name="ossfile"
                  :data="Uploadeimg"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess4"
                  :disabled="!!editForm.promotion_protocolfile"
                  accept=".doc, .docx, .docm, .dotx, .xls, .xlsx, .xlsm, .pdf, .png, .jpeg, .gif"
                >
                  <el-button
                    type="primary"
                    :disabled="!!editForm.promotion_protocolfile"
                  >
                    上传
                  </el-button>
                </el-upload>
                <span class="file-item" v-if="editForm.promotion_protocolfile">
                  {{ editForm.promotion_protocolfile }}
                  <em
                    class="el-icon-error"
                    @click="editForm.promotion_protocolfile = ''"
                  ></em>
                </span>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmEdit" type="primary" size="small"
            >确定</el-button
          >
          <el-button @click="editVisible = false" size="small">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import PageNav from "../../components/Nav/nav.vue";
import SliderBox from "../../components/SliderBox";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";
import normalTableCont from "../../components/tables/switchTableCont.vue";
export default {
  name: "Activitiesmanage-activitiesManage",
  data() {
    var checkPhone = (rule, value, callback) => {
      // const reg = /^1(\d){10}$/;
      let reg = "";
      if (this.$userinfo.language_type == "tw") {
        reg = /^09(\d){8}$/;
      } else {
        reg = /^1[3-9](\d){9}$/;
      }
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error("手机号格式不正确"));
      }
      // CrmActiveManage.getPromotion({
      //   promotion_mobile: value,
      // }).then((res) => {
      //   if (!value) {
      //     return callback(new Error("手机号不能为空"));
      //   } else {
      //     const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
      //     if (reg.test(value)) {
      //       if (res.data.code !== 200) {
      //         (() => {})("dd");
      //         return callback(new Error("用户已存在"));
      //       } else {
      //         callback();
      //       }
      //     } else {
      //       return callback(new Error("请输入正确的手机号"));
      //     }
      //   }
      // });
    };
    var checkJobnumber = (rule, value, callback) => {
      CrmActiveManage.getPromotion({
        promotion_jobnumber: value,
      }).then((res) => {
        if (!value) {
          return callback(new Error("地推工号不能为空"));
        } else {
          if (res.data.code !== 200) {
            return callback(new Error("地推工号已存在"));
          } else {
            callback();
          }
        }
      });
    };
    return {
      checkPhone,
      checkJobnumber,
      Uploadeimg: {
        company_id: "",
        ossfile: "",
      },
      selectForms: {
        open_status: "",
        promotion_type: "",
        keyword: "",
      },

      openMenu: ["1"],
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      currentPage: 1,

      tableList: {
        list: [],
        columns: [],
        options: {
          mutiSelect: false,
          tableHeight: null, //表格高度
          errortip: "",
          issetting: false,
        },
      },
      addVisible: false,
      editVisible: false,
      formData: {
        codeList: [
          {
            promotion_name: "",
            promotion_sex: "",
            promotion_mobile: "",
            // promotion_jobnumber: "",
            promotion_type: "0",
            promotion_mode: "",
            promotion_salarycycle: "",
            promotion_bankcard: "",
            promotion_bank: "",
            promotion_idcard: "",
            promotion_idcardfile: "",
            promotion_protocolfile: "",
          },
        ],
      },
      editForm: {
        promotion_name: "",
        promotion_sex: "",
        promotion_mobile: "",
        promotion_jobnumber: "",
        promotion_mode: "",
        promotion_salarycycle: "",
        promotion_bankcard: "",
        promotion_bank: "",
        promotion_idcard: "",
        promotion_idcardfile: "",
        promotion_protocolfile: "",
      },
      promotionObj: null,
    };
  },
  components: {
    PageNav,
    SliderBox,
    normalTableCont,
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.Uploadeimg.company_id = this.company_id;
    this.getGroundPromotion();
  },
  methods: {
    handleAvatarSuccess1(res) {
      const { code, data } = res;
      if (code === 200) {
        this.formData.codeList.forEach((v) => {
          v.promotion_idcardfile = data.picture_imgurl;
        });
      }
    },

    handleAvatarSuccess2(res) {
      const { code, data } = res;
      if (code === 200) {
        this.formData.codeList.forEach((v) => {
          v.promotion_protocolfile = data.picture_imgurl;
        });
      }
    },
    handleAvatarSuccess3(res) {
      const { code, data } = res;
      if (code === 200) {
        this.editForm.promotion_idcardfile = data.picture_imgurl;
      }
    },

    handleAvatarSuccess4(res) {
      const { code, data } = res;
      if (code === 200) {
        this.editForm.promotion_protocolfile = data.picture_imgurl;
      }
    },

    getGroundPromotion() {
      CrmActiveManage.getGroundPromotion({
        keyword: this.selectForms.keyword,
        open_status: this.selectForms.open_status,
        promotion_type: this.selectForms.promotion_type,
        p: this.currentPage,
        num: this.pagesize,
        is_count: "1", // 是否需要总数
      }).then((res) => {
        let columns = res.data.data.field;
        columns.forEach((v) => {
          if (v.fieldname === "open_status") {
            this.$set(v, "switch", true);
          }
        });
        this.tableList.columns = columns;
        this.dataNumber = parseInt(res.data.data.allnum);
        if (res.data.code === 200) {
          this.tableList.list = res.data.data.list;
        } else {
          this.tableList.list = [];
          this.tableList.options.errortip = res.data.msg;
        }
      });
    },
    addPerson() {
      this.resetForm();
      this.addVisible = true;
    },
    resetForm() {
      this.formData = {
        codeList: [
          {
            promotion_name: "",
            promotion_sex: "",
            promotion_mobile: "",
            // promotion_jobnumber: "",
            promotion_type: "0",
            promotion_mode: "",
            promotion_salarycycle: "",
            promotion_bankcard: "",
            promotion_bank: "",
            promotion_idcard: "",
            promotion_idcardfile: "",
            promotion_protocolfile: "",
          },
        ],
      };

      if (this.$refs.formData) {
        this.$refs.formData.resetFields();
      }
    },
    addItem() {
      this.formData.codeList.push({
        promotion_name: "",
        promotion_sex: "",
        promotion_mobile: "",
        // promotion_jobnumber: "",
        promotion_type: "0",
        promotion_mode: "",
        promotion_salarycycle: "",
        promotion_bankcard: "",
        promotion_bank: "",
        promotion_idcard: "",
        promotion_idcardfile: "",
        promotion_protocolfile: "",
      });
    },
    delItem(k) {
      this.formData.codeList.splice(k, 1);
    },
    onSwitchChange(v) {
      (() => {})(v.open_status);
      CrmActiveManage.openGroundPromotionAction({
        open_status: v.open_status,
        promotion_id: v.promotion_id,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.getGroundPromotion();
      });
    },
    triggerSubmit() {
      let promotion_json = [];
      this.formData.codeList.map((v) => {
        promotion_json.push({
          promotion_name: v.promotion_name,
          promotion_sex: v.promotion_sex,
          promotion_mobile: v.promotion_mobile,
          // promotion_jobnumber: v.promotion_jobnumber,
          promotion_type: v.promotion_type,
          promotion_mode: v.promotion_mode,
          promotion_salarycycle: v.promotion_salarycycle,
          promotion_bankcard: v.promotion_bankcard,
          promotion_bank: v.promotion_bank,
          promotion_idcard: v.promotion_idcard,
          promotion_idcardfile: v.promotion_idcardfile,
          promotion_protocolfile: v.promotion_protocolfile,
        });
      });
      CrmActiveManage.addGroundPromotionAction({
        promotion_json: JSON.stringify(promotion_json),
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.addVisible = false;
          this.getGroundPromotion();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    submit() {
      let validateArr = [];
      this.formData.codeList.forEach((item, index) => {
        this.$refs[`Setup${index}`][0].validate((valid) => {
          validateArr.push(valid);
          if (validateArr.length === this.formData.codeList.length) {
            let canSubmit = validateArr.every((v) => v);
            if (canSubmit) {
              this.triggerSubmit();
            }
          }
        });
      });
    },
    onClickEdit(v) {
      this.editVisible = true;
      this.promotionObj = v;
      this.editForm.promotion_name = v.promotion_name;
      this.editForm.promotion_sex = v.promotion_sex;
      this.editForm.promotion_mobile = v.promotion_mobile;
      this.editForm.promotion_type = v.promotion_type;
      this.editForm.promotion_mode = v.promotion_mode;
      this.editForm.promotion_salarycycle = v.promotion_salarycycle;
      this.editForm.promotion_jobnumber = v.promotion_jobnumber;
      this.editForm.promotion_bankcard = v.promotion_bankcard;
      this.editForm.promotion_bank = v.promotion_bank;
      this.editForm.promotion_idcard = v.promotion_idcard;
      this.editForm.promotion_idcardfile = v.promotion_idcardfile;
      this.editForm.promotion_protocolfile = v.promotion_protocolfile;
    },
    confirmEdit() {
      this.$refs.editForm.validate((val) => {
        if (val) {
          CrmActiveManage.editGroundPromotionAction({
            promotion_id: this.promotionObj.promotion_id,
            promotion_name: this.editForm.promotion_name,
            promotion_sex: this.editForm.promotion_sex,
            promotion_mode: this.editForm.promotion_mode,
            promotion_salarycycle: this.editForm.promotion_salarycycle,
            promotion_bankcard: this.editForm.promotion_bankcard,
            promotion_bank: this.editForm.promotion_bank,
            promotion_idcard: this.editForm.promotion_idcard,
            promotion_idcardfile: this.editForm.promotion_idcardfile,
            promotion_protocolfile: this.editForm.promotion_protocolfile,
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.editVisible = false;
              this.getGroundPromotion();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getGroundPromotion();
    },

    // 页码变化
    curPageChange(v) {
      this.currentPage = v;
      this.getGroundPromotion();
    },
    // pageSize改变
    pageSizeChange() {
      this.currentPage = 1;
      this.getGroundPromotion();
    },
    handClose(done) {
      done();
    },
    getPromotion(promotion_mobile, index) {
      if (!promotion_mobile) return;
      CrmActiveManage.getPromotion({
        promotion_mobile,
      }).then((res) => {
        if (res.data.code !== 200) {
          this.formData.codeList[index].promotion_name =
            res.data.data.promotion_name;
          this.formData.codeList[index].disabled = true;
          this.$message({
            message: "该手机号已存在",
            type: "error",
          });
        }
      });
    },
    getJobnumber(promotion_jobnumber) {
      if (!promotion_jobnumber) return;
      CrmActiveManage.getPromotion({
        promotion_jobnumber,
      }).then((res) => {
        if (res.data.code !== 200) {
          this.$message({
            message: "该地推工号已存在",
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 90
        );
      }
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("crmActiveManage.less");

.file-item {
  width: 260px;
  margin-left: 10px;
  line-height: 30px;
  border: 1px solid #ddd;
  border-radius: 4px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  padding: 0 25px 0 10px;
  position: relative;

  em {
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    cursor: pointer;
  }
}
.delete-tips {
  padding: 45px 0;
  font-size: 14px;
  text-align: center;
  color: #333;
}
.groundPromotion-manage-drawer {
  .el-form {
    padding: 0 !important;
  }
  margin: 40px;
  .add-icon {
    display: inline-flex;
    cursor: pointer;
    font-size: 14px;
    color: #22a9d7;
    i {
      margin-right: 8px;
      cursor: pointer;
      font-size: 18px;
    }
  }
  .code_list {
    padding: 20px 20px 5px !important;
    margin-bottom: 20px;
    background: #f7f9fb;
    border-radius: 10px;
    border: 1px solid #eaeef5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .code-remove {
      margin: 8px;
      i {
        cursor: pointer;
        font-size: 24px;
        color: #e1e1e1;
      }
      &:hover {
        opacity: 1;
      }
    }
  }
}
</style>
